import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Document, DocumentCreate, DocumentFilter } from '../data/document';

export function createDocumentService(client: AxiosInstance) {
  return createCrudService<Document, DocumentCreate, DocumentFilter>(
    client,
    '/document-management/Document',
    'id',
  );
}

export type DocumentService = CrudService<Document, DocumentCreate, DocumentFilter>;
